import { render } from "./AddVotingModal.vue?vue&type=template&id=6981e558&scoped=true"
import script from "./AddVotingModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddVotingModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddVotingModal.vue?vue&type=style&index=0&id=6981e558&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6981e558"]])

export default __exports__